// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1J6Gz","left":"styles_left__2QPAd"};